import type { Catalog } from "../../en";
import { common } from "./common";
import { dashboard } from "./dashboard";
import { tenants } from "./tenants";
import { tenantDetail } from "./tenant-detail";
import { usage } from "./usage";
import { plans } from "./plans";
import { aiModels } from "./ai-models";
import { system } from "./system";
import { support } from "./support";
import { audit } from "./audit";
import { staff } from "./staff";
import { settings } from "./settings";
import { customPlan, manualBilling, salesRequests } from "./sales-requests";

/** Filipino: platform admin screens (P9, mirrors en). */
export const adminScreens: Catalog["adminScreens"] = {
  common,
  dashboard,
  tenants,
  tenantDetail,
  usage,
  plans,
  aiModels,
  system,
  support,
  audit,
  staff,
  settings,
  salesRequests,
  manualBilling,
  customPlan,
};
